import store from 'Store'

const Alerts = {

    install(Vue) {
        const DEFAULT_TIMEOUT = 5000

        Vue.prototype.$alert = {
            success: function (title, body, timeout = DEFAULT_TIMEOUT) {
                store.dispatch('ADD_ALERT', {
                    type: 'success',
                    title,
                    body,
                    timeout
                })
            },

            error: function (title, body, timeout = DEFAULT_TIMEOUT) {
                store.dispatch('ADD_ALERT', {
                    type: 'error',
                    title,
                    body,
                    timeout
                })
            },

            warning: function (title, body, timeout = DEFAULT_TIMEOUT) {
                store.dispatch('ADD_ALERT', {
                    type: 'warning',
                    title,
                    body,
                    timeout
                })
            },

            info: function (title, body, timeout = DEFAULT_TIMEOUT) {
                store.dispatch('ADD_ALERT', {
                    type: 'info',
                    title,
                    body,
                    timeout
                })
            }
        }
    }

}

export default Alerts
